/**
 * @file util.screenshot.js
 *
 * This file will be used to help generate screenshots states such as:
 *
 * To activate this just add the URL parameter "ed=1".
 *
 * Assumptions:
 * - This file is required for all stages of the site (dev, staging, and live) for screenshots
 * - This file only contains certain functions for screenshoting copy changes (accessibility)
 */
import PL_utils from './vendor/pl-utils.js';

export default() => {
    const el_body = document.querySelector('body');
    const isEDMode = window.location.href.indexOf('ed=1') >= 0;
    const TIMEOUT_DELAY = 500;
    const mobileDevice = 1025;
    // Determine if "ed=1" is in the URL.
    if (isEDMode) {
        el_body.classList.add('editorial');

        //skip to content
        if(window.location.href.indexOf('skip-to-content=1') > 0){
            const target = document.querySelector('.skip-to-content');
            PL_utils.addClass('screenshot', target);
        }

        // add hover/focus states
        if (window.location.href.indexOf('links=hover') > 0) {
            PL_utils.addClass('hover-ss', el_body);
        }


        if ( window.location.href.indexOf('recognizing-patterns-addiction') > 0 ) {
            setTimeout( () => {
                document.querySelector('.editorial .video-segment[data-title="Recognizing Patterns of Addiction Symptoms"]').classList.add('active');
            }, TIMEOUT_DELAY);
        }

        //scroll videos
        if ( window.location.href.indexOf('scrollVideos') > 0 ) {
            document.body.classList.add('all-video-segments');
            document.querySelector('.video-segment-list[role="listbox"]').style.height = 'auto';
            document.querySelector('.video-segment-list[role="listbox"]').style.overflow = 'inherit';
        }

        //Cookies banner
        if (window.location.href.indexOf('cookieBanner') > -1) {
            setTimeout(() => {
                document.querySelector('html').style.overflow = 'visible';
            }, 5000);
            document.querySelector('body').classList.add('cookies');
        }
        if (window.location.href.indexOf('cookieBannerHover') > -1) {
            document.querySelector('body').classList.add('cookies-hover');
        }
        if (window.location.href.indexOf('cookieBannerFocus') > -1) {
            document.querySelector('body').classList.add('cookies-focus');
        }
        if (window.location.href.indexOf('cookieBannerRejected') > -1) {
            setTimeout(() => {
                document.querySelectorAll('.ot-tgl input').forEach(e => {
                    e.click();
                })
            }, 5000)
        }
        if (window.location.href.indexOf('cookieBannerExpanded') > -1) {
            document.querySelector('body').classList.add('cookies-expanded');
            setTimeout(() => {
                document.querySelectorAll('button[ot-accordion="true"]').forEach(e => {
                    e.click();
                })
            }, 5000)
        }
    }

    // Otherwise do nothing.
    else {
        return false;
    }
};
